import * as React from 'react'
import UserStore from '../../../Stores/UserStore'
import { history } from '../../../Routing'

export interface ILogoutPageProps {
}

export default class LogoutPage extends React.Component<ILogoutPageProps> {

    constructor(props: any) {
        super(props)
        
        UserStore.getInstance().killSession()
        history.push('/login')
    }

    render() {
        return (
            <div />
        )
    }

}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Views/Pages/Account/LogoutPage.tsx